import React, {Component} from 'react'
import {connect} from 'react-redux'
import {toggleModal} from "../../Actions/ToggleModal";
import {modifyPaymentModalOrigin} from "../../Actions/ModifyPaymentModalOrigin";
import { Button } from 'semantic-ui-react'
import {isMobile} from "react-device-detect";
import {isUserV2Customer} from "../../Constants/isUserV2Customer";
import GoToBillingPortalBtn from "./GoToBillingPortalBtn";

class UpgradeButton extends Component {
    openPaymentModal = () => {
        this.props.modifyPaymentModalOrigin(null)
        this.props.toggleModal("paymentModal")
    }

    render() {
        if (isUserV2Customer()){
            return <GoToBillingPortalBtn />
        } else {
            return (
                <Button color="green"
                        onClick={this.openPaymentModal}
                        content={<h4><b>Upgrade <span role="img" aria-label="smile" style={{paddingLeft: '2px'}}>😀</span></b></h4>}
                        style={isMobile ? {marginTop: '10px'} : null}
                />
            )
        }

    }
}

const mapStateToProps = (state) => ({
    // isGrandfather: state.mainState.isGrandfather
})

const mapActionsToProps = {
    toggleModal: toggleModal,
    modifyPaymentModalOrigin: modifyPaymentModalOrigin
}

export default connect(mapStateToProps, mapActionsToProps)(UpgradeButton)